export default function logError(...args: any[]) {
  // tslint:disable-next-line: no-console
  console.error(...args);
}
